import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';
import { environment } from '@environments/environment';

import Auth from '@aws-amplify/auth';
import { AuthUtil, AuthService } from '@examsoft/es-login';
import { LayoutState, CloseMenu, OpenMenu, OpenTimer } from '../../store';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnDestroy {
  @Select(LayoutState.getShowMenu) showMenu$: Observable<boolean>;
  public fullName;
  public homeUrl;
  public isAdmin;
  private auth;

  constructor(
    private authService: AuthService,
    private authUtil: AuthUtil,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store
  ) {
    this.auth = this.authService.user$.subscribe(data => {
      this.fullName = `${data.given_name} ${data.family_name}`;
      this.isAdmin = authService.isAdmin();
    });
  }

  closeNav(event) {
    this.store.dispatch(new CloseMenu());
    event.stopPropagation();
  }

  openNav(event) {
    this.store.dispatch(new OpenMenu());
    event.stopPropagation();
  }

  showTimer() {
    this.store.dispatch(new OpenTimer());
  }

  signOut() {
    this.store.dispatch(new CloseMenu());
    this.logout();
  }

  logout() {
    let domain = environment.aws.oauth.domain;
    let clientId = environment.aws.Auth.userPoolWebClientId;
    let logout = environment.esLogin;
    let url = `https://${domain}/logout?client_id=${clientId}&logout_uri=${logout}`;
    Auth.signOut().then(() => {
      window.location.href = url;
    });
  }

  ngOnDestroy() {
    this.auth.unsubscribe();
  }
}
